export default __webpack_public_path__ + "bb6dbff2a7f90ec51fb10c87f0d8efb1.png";